import { render, staticRenderFns } from "./AllDdjs.vue?vue&type=template&id=615f8531&scoped=true&"
import script from "./AllDdjs.vue?vue&type=script&lang=js&"
export * from "./AllDdjs.vue?vue&type=script&lang=js&"
import style0 from "./AllDdjs.vue?vue&type=style&index=0&id=615f8531&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f8531",
  null
  
)

export default component.exports